import { Optional, Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

@Pipe({
    name: "monthsToYearsAndMonths",
    standalone: false,
    pure: false,
})
export class MonthsToYearsAndMonthsPipe implements PipeTransform {
  constructor(@Optional() private readonly _translocoService: TranslocoService) {}

  transform(value: number) {
    const numberOfYears = value ? Math.floor(value / 12) : 0;
    const numberOfMonths = value ? value - numberOfYears * 12 : 0;
    const yearsLabel = this._translocoService?.translate('common.years') ?? 'year(s)';
    const monthsLabel = this._translocoService?.translate('common.months') ?? 'month(s)';
    return `${numberOfYears} ${yearsLabel} ${numberOfMonths} ${monthsLabel}`;
  }
}
